// extracted by mini-css-extract-plugin
module.exports = {"loader":"Loader_loader__yiz6V","loaderFull":"Loader_loaderFull__ZUJwP","spinner":"Loader_spinner__FnuQR"};